import { useContext } from "react";
import ReactPlayer from "react-player";
import { FaArrowDown, FaVolumeUp, FaVolumeMute, FaPlay } from "react-icons/fa";

import {
	Img,
	Flex,
	Show,
	Stack,
	Heading,
	AspectRatio,
	useBoolean,
} from "@chakra-ui/react";

import { VideoContext } from "../App";
import { MediaButton } from "./MediaButton";

import view from "../media/view2.jpg";

export const VideoPlayer = () => {
	const [isMuted, setIsMuted] = useBoolean(true);

	const videoContext = useContext(VideoContext);
	const hideVideo = videoContext?.hideVideo;
	const setHideVideo = videoContext?.setHideVideo;

	return (
		<Stack w="100%" gap="0" justify="flex-start">
			<Flex
				w="100%"
				zIndex={3}
				align="center"
				position="absolute"
				justify="space-between"
				px={{ base: "3", lg: "5", xl: "6" }}
				mt={{ base: "2", md: "3", lg: "4", xl: "5" }}
			>
				<Show above="md">
					<Heading pl="1" color="brand.light">
						HONEY, YOU'RE HOME
					</Heading>
				</Show>

				<Flex gap="2">
					<Show above="md">
						<MediaButton
							icon={FaArrowDown}
							label="scroll down"
							onClick={() => window.location.replace("/#experience")}
						/>
					</Show>

					{hideVideo ? (
						<MediaButton
							icon={FaPlay}
							label="play"
							onClick={() => {
								if (setHideVideo) setHideVideo?.off();
							}}
						/>
					) : (
						<MediaButton
							icon={isMuted ? FaVolumeMute : FaVolumeUp}
							label={isMuted ? "unmute" : "mute"}
							onClick={setIsMuted.toggle}
						/>
					)}
				</Flex>
			</Flex>

			{hideVideo ? (
				<AspectRatio
					zIndex={2}
					ratio={16 / 9}
					maxW={{ base: "auto", md: "100vw" }}
				>
					<Img src={view} alt="Welcome" objectFit="cover" />
				</AspectRatio>
			) : (
				<AspectRatio
					zIndex={2}
					ratio={16 / 9}
					objectFit="cover"
					backgroundSize="cover"
					bgImg={`url(${view})`}
					maxW={{ base: "auto", md: "100vw" }}
				>
					<ReactPlayer
						playing={!hideVideo}
						width="100%"
						height="auto"
						muted={isMuted}
						onEnded={setHideVideo?.on}
						url="https://player.vimeo.com/video/1087601980?h=f2bb4b94ee"
					/>
				</AspectRatio>
			)}
		</Stack>
	);
};
